import { render, staticRenderFns } from "./dragDropBlock.vue?vue&type=template&id=48824d99&"
import script from "./dragDropBlock.vue?vue&type=script&lang=js&"
export * from "./dragDropBlock.vue?vue&type=script&lang=js&"
import style0 from "./dragDropBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports